import { render, staticRenderFns } from "./SelectUnavailabilityType.vue?vue&type=template&id=1d05b2b2&scoped=true&"
import script from "./SelectUnavailabilityType.vue?vue&type=script&lang=js&"
export * from "./SelectUnavailabilityType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d05b2b2",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSelect});
